import ErrorPage from "./views/ErrorPage";
import { Routes, Route, BrowserRouter as Router } from "react-router-dom";
import Home from "./views/home/Home";
import Cartes from "./views/cartes/Cartes";
import Events from "./views/event/Events";
import Contact from "./views/contact/Contact";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { getLANG } from "./actions/langue.action";
import GlobalStructureDashbaord from "./components/layout/GlobalStructureDashbaord";
import GlobalStructureWebsite from "./components/layout/GlobalStructureWebsite";
import Login from "./views/login/Login";
import BookingAdmin from "./views/admin/bookingAdmin/BookingAdmin";
import EventsAdmin from "./views/admin/events-admin/EventsAdmin";
import CarteAdmin from "./views/admin/carte-admin/CarteAdmin";
import TermAndPolicy from "./views/term-policy/TermAndPolicy";
import Profile from "./views/admin/profile/Profile";
import Logout from "./views/Logout";
import { bookingOpen } from "./actions/booking.action";
import DayLock from "./views/admin/dayLock/DayLock";
import Choice from "./views/cartes/Choice";

const App = () => {
  const dispatch: any = useDispatch();
  useEffect(() => {
    dispatch(getLANG("FR"));
    dispatch(bookingOpen(false))
  }, []);
  return (
    <Router>
      <Routes>
        <Route path="*" element={<ErrorPage />} />
        <Route
          path="/"
          element={
            <GlobalStructureWebsite>
              {" "}
              <Home />{" "}
            </GlobalStructureWebsite>
          }
        />
        <Route
          path="/policy"
          element={
            <GlobalStructureWebsite>
              {" "}
              <TermAndPolicy />{" "}
            </GlobalStructureWebsite>
          }
        />
        <Route
          path="/cartes"
          element={
            <GlobalStructureWebsite>
              {" "}
              <Cartes />{" "}
            </GlobalStructureWebsite>
          }
        />
        <Route
          path="/cartes/:id"
          element={
            <GlobalStructureWebsite>
              {" "}
              <Choice />{" "}
            </GlobalStructureWebsite>
          }
        />
        <Route
          path="/events"
          element={
            <GlobalStructureWebsite>
              {" "}
              <Events />{" "}
            </GlobalStructureWebsite>
          }
        />
        <Route
          path="/contact"
          element={
            <GlobalStructureWebsite>
              {" "}
              <Contact />{" "}
            </GlobalStructureWebsite>
          }
        />
        <Route path="/blr-admin" element={<Login />} />
        <Route
          path="/menu-admin"
          element={
            <GlobalStructureDashbaord>
              {" "}
              <CarteAdmin />{" "}
            </GlobalStructureDashbaord>
          }
        />
        <Route
          path="/reservation-admin"
          element={
            <GlobalStructureDashbaord>
              {" "}
              <BookingAdmin />{" "}
            </GlobalStructureDashbaord>
          }
        />
        <Route
          path="/event-admin"
          element={
            <GlobalStructureDashbaord>
              {" "}
              <EventsAdmin />{" "}
            </GlobalStructureDashbaord>
          }
        />
        <Route
          path="/profil"
          element={
            <GlobalStructureDashbaord>
              {" "}
              <Profile />{" "}
            </GlobalStructureDashbaord>
          }
        />
        <Route
          path="/daylock"
          element={
            <GlobalStructureDashbaord>
              {" "}
              <DayLock />{" "}
            </GlobalStructureDashbaord>
          }
        />
        <Route path="/logout" element={<Logout />} />
      </Routes>
    </Router>
  );
};

export default App;
